import { ArrowLongRightIcon } from '@heroicons/react/24/solid'
import { Button } from '@mui/material'
import { motion } from 'framer-motion';
import { fadeIn, staggerContainer } from '../../utils/motion';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const DevBanner = ({ data }) => {

    const navigate = useNavigate()

    return (
        <>

            <Helmet >
                <title>CodeZone | {data.title} {data.title2}</title>
            </Helmet>

            <div className='max-w-screen-2xl mx-auto py-5 md:py-8 px-2 md:px-10'>
                <motion.div
                    variants={staggerContainer}
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true }}>

                    <div className='grid grid-cols-1 md:grid-cols-2 items-center gap-7 md:gap-4'>
                        <motion.div
                            variants={fadeIn('right', 'tween', 0, 1.0)}
                        >
                            <div className='p-2'>
                                <h1 className='font-bold text-2xl text-center md:text-left dark:text-white md:text-3xl'>Hire <span className='text-red-500'>{data.title}</span> {data.title2}</h1>
                                <p className='my-4 text-gray-500 dark:text-gray-300 text-xs'>{data.desc}</p>
                                <div className='space-y-2'>
                                    {data.points.map((item, i) => (
                                        <motion.div
                                            variants={fadeIn('right', 'tween', 0.6 + (i - 0.8), 0.7)}
                                        >
                                            <div key={i} className='flex gap-2 items-center'>
                                                <div >
                                                    <ArrowLongRightIcon className='text-red-500 h-7' />
                                                </div>
                                                <p className='text-sm dark:text-white'>{item}</p>
                                            </div>
                                        </motion.div>
                                    ))}
                                </div>
                                <div className=' mt-3 flex justify-center md:justify-start'>
                                    <Button
                                        onClick={() => navigate('/contact-us')}
                                        variant='contained' color='error'
                                        className='blob-btn'
                                        size='large'

                                        sx={{
                                            borderRadius: '30px',
                                            fontSize: '16px',
                                            backgroundColor: 'black !important',
                                            marginTop: '20px',
                                            textTransform: 'none',
                                            transition: 'all 0.7s ease-in-out',
                                            '&:hover': {
                                                boxShadow: '0 0 20px rgba(0,0,0,0.3)',
                                                transform: 'scale(1.1)'
                                            }
                                        }}
                                    >
                                        Hire {data.title} Experts
                                        <span class="blob-btn__inner">
                                            <span class="blob-btn__blobs">
                                                <span class="blob-btn__blob"></span>
                                                <span class="blob-btn__blob"></span>
                                                <span class="blob-btn__blob"></span>
                                                <span class="blob-btn__blob"></span>
                                            </span>
                                        </span>

                                    </Button>
                                </div>
                            </div>
                        </motion.div>
                        <motion.div
                            variants={fadeIn('left', 'tween', 0, 1.0)}
                        >
                            <div className='flex items-center justify-center'>
                                <img src={data.img} alt="img"
                                    className='object-contain h-[350px] cursor-pointer w-[80%] md:w-full'
                                    onClick={() => navigate('/contact-us')}

                                />
                            </div>
                        </motion.div>
                    </div>
                </motion.div>
            </div>
        </>
    )
}

export default DevBanner